import { Component, OnInit } from '@angular/core';
import { GlobalState } from '../../shared/global.state';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss']
})
export class LayoutComponent implements OnInit {
  loading = false;
  constructor(private _state: GlobalState) { }

  ngOnInit() {
    this._state.watch('[PENDING_REQUEST] UPDATE').subscribe((count) => {
      if (count !== 0) {
        this.loading = true;
      } else {
        this.loading = false;
      }
    });
  }

}
